import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const GatosPage = lazy(() => import('../pages/gatos/page'));
const PerrosPage = lazy(() => import('../pages/perros/page'));
const ConejosPage = lazy(() => import('../pages/conejos/page'));
const HuronesPage = lazy(() => import('../pages/hurones/page'));
const ErizosPage = lazy(() => import('../pages/erizos/page'));
const CobayasPage = lazy(() => import('../pages/cobayas/page'));
const ChinchillasPage = lazy(() => import('../pages/chinchillas/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/gatos',
    element: <GatosPage />,
  },
  {
    path: '/perros',
    element: <PerrosPage />,
  },
  {
    path: '/conejos',
    element: <ConejosPage />,
  },
  {
    path: '/hurones',
    element: <HuronesPage />,
  },
  {
    path: '/erizos',
    element: <ErizosPage />,
  },
  {
    path: '/cobayas',
    element: <CobayasPage />,
  },
  {
    path: '/chinchillas',
    element: <ChinchillasPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;